var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ICON_-_Download","data-name":"ICON - Download","transform":"translate(1 1)"},React.createElement("path",{"id":"Path_2312","data-name":"Path 2312","d":"M309.647,391.519v5.748h22.99v-5.748m-17.243-5.746,5.748,5.747V377.151m5.748,8.621-5.748,5.748","transform":"translate(-309.647 -377.151)","fill":"none","stroke":"#27788C","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"})));
}

DownloadIcon.defaultProps = {"width":"24.99","height":"22.116","viewBox":"0 0 24.99 22.116"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
